import { Batch } from 'src/app/models/batch';
import { BatchQuery } from 'src/app/models/batch-query';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface BatchTableState {
    query: BatchQuery;
    page: Batch[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
}

export const selectBatchTableState = (state: AppState) => state.batchTable;

export const selectBatchTableQuery = createSelector(selectBatchTableState,
    (state: BatchTableState) => state.query);

export const selectBatchTablePage = createSelector(selectBatchTableState,
    (state: BatchTableState) => state.page);

export const selectBatchTableBusy = createSelector(selectBatchTableState,
    (state: BatchTableState) => state.busy);

export const selectBatchTableCount = createSelector(selectBatchTableState,
    (state: BatchTableState) => state.totalCount);

export const selectBatchTableSelection = createSelector(selectBatchTableState,
    (state: BatchTableState) => state.selection);
